import React from 'react';
import {
  Page,
  Document,
  Image,
  Text,
  View,
  StyleSheet,
  Font,
} from '@react-pdf/renderer';
// import InvoiceTitle from './InvoiceTitle';
// import BillTo from './BillTo';
// import InvoiceNo from './InvoiceNo';
// import InvoiceItemsTable from './InvoiceItemsTable';
// import InvoiceThankYouMsg from './InvoiceThankYouMsg';
// import logo from '../../../src/logo.png';
import {
  DataTableCell,
  Table,
  TableBody,
  TableCell,
  TableHeader,
} from '@david.kucsai/react-pdf-table';
import font from '../../../../THSarabunNew.ttf';
import fontBold from '../../../../THSarabunNewBold.ttf';

//https://builtbydamian.com/blog/react-generate-pdf/
//https://github.com/dmk99/react-pdf-table

Font.register('https://fonts.gstatic.com/s/kadwa/v2/rnCm-x5V0g7ipiTAT8M.ttf', {
  family: 'KadwaRegular',
});
Font.register(
  'https://fonts.gstatic.com/s/kadwa/v2/rnCr-x5V0g7ipix7atM5kn0.ttf',
  { family: 'KadwaBold' }
);
Font.register(
  'https://fonts.gstatic.com/s/montserrat/v12/JTUSjIg1_i6t8kCHKm459Wlhzg.ttf',
  { family: 'MontserratRegular' }
);

Font.register({ family: 'Sarabun', src: font });
Font.register({ family: 'SarabunBold', src: fontBold });

const styles = StyleSheet.create({
  header: {
    borderTopWidth: 4,
    borderTopColor: '#0084B4',
    color: '#898989',
    padding: 20,
    display: 'flex',
    flexDirection: 'row',
  },
  headerLeft: {
    textAlign: 'center',
    // flex: 1,
    // alignSelf: 'center',
    fontSize: 20,
    // fontWeight: 900,
    // lineHeight: 1,
    // color: '#0084B4',
    fontFamily: 'SarabunBold',
  },
  header1: {
    textAlign: 'right',
    fontSize: 16,
    // flex: 1,
    fontFamily: 'Sarabun',
  },
  header2: {
    textAlign: 'center',
    fontSize: 20,
    flex: 1,
    fontFamily: 'SarabunBold',
  },
  header3: {
    textAlign: 'center',
    fontSize: 16,
    // flex: 1,
    fontFamily: 'SarabunBold',
  },
  header4: {
    textAlign: 'right',
    fontSize: 16,
    paddingRight: 20,
    // flex: 1,
    fontFamily: 'Sarabun',
  },
  detail1: {
    textAlign: 'right',
    fontSize: 16,
    display: 'flex',
    paddingRight: 20,
    flexDirection: 'row',
    // flex: 1,
    fontFamily: 'Sarabun',
  },
  detail2: {
    textAlign: 'left',
    fontSize: 16,
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 20,
    // flex: 1,
    fontFamily: 'Sarabun',
  },
  detail3: {
    textAlign: 'left',
    fontSize: 16,
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 60,
    // flex: 1,
    fontFamily: 'Sarabun',
  },
  detail4: {
    textAlign: 'left',
    fontSize: 16,
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 80,
    // flex: 1,
    fontFamily: 'Sarabun',
  },

  ribbon: {
    backgroundColor: '#0084B4',
    display: 'flex',
    flexDirection: 'row',
    padding: 20,
    marginBottom: 20,
    textAlign: 'center',
    color: '#FFF',
  },
  ribbonGrey: {
    backgroundColor: '#EDEDED',
    display: 'flex',
    flexDirection: 'row',
    padding: 20,
    marginBottom: 20,
    textAlign: 'center',
    color: '#0084B4',
  },
  ribbonBox: {
    width: '33.333333%',
  },
  ribbonLabel: {
    fontSize: 14,
    fontFamily: 'KadwaBold',
  },
  ribbonValue: {
    fontSize: 28,
    fontFamily: 'KadwaBold',
  },

  table: {
    paddingHorizontal: 20,
    display: 'flex',
    marginBottom: 20,
  },
  tableRowA: {
    backgroundColor: '#EDEDED',
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
  },
  tableRowB: {
    padding: 10,
    display: 'flex',
    flexDirection: 'row',
  },
  serviceName: {
    fontSize: 10,
    width: '25%',
    fontFamily: 'KadwaBold',
  },
  serviceDescription: {
    fontSize: 10,
    width: '50%',
    fontFamily: 'MontserratRegular',
  },
  serviceDescriptionThai: {
    fontSize: 20,
    width: '50%',
    fontFamily: 'Sarabun',
  },
  serviceAmount: {
    fontSize: 20,
    width: '25%',
    textAlign: 'right',
    fontFamily: 'KadwaBold',
  },
  tableHeadingA: {
    width: '25%',
    fontSize: 14,
    color: '#0084B4',
    fontFamily: 'KadwaBold',
  },
  tableHeadingB: {
    width: '50%',
    fontSize: 14,
    color: '#0084B4',
    fontFamily: 'KadwaBold',
  },
  tableHeadingC: {
    width: '25%',
    textAlign: 'right',
    fontSize: 14,
    color: '#0084B4',
    fontFamily: 'KadwaBold',
  },
  summary: {
    backgroundColor: '#0084B4',
    color: '#FFF',
    padding: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  summaryMeta: {
    width: '75%',
    fontFamily: 'KadwaBold',
  },
  summaryAmount: {
    fontSize: 20,
    width: '25%',
    textAlign: 'right',
    fontFamily: 'KadwaBold',
  },

  howToPay: {
    paddingHorizontal: 20,
    textAlign: 'center',
    fontSize: 20,
    color: '#0084B4',
    fontFamily: 'KadwaBold',
  },

  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 20,
    borderTopColor: '#EDEDED',
    borderTopWidth: 1,
    textAlign: 'center',
    fontSize: 10,
    fontFamily: 'MontserratRegular',
  },
});

const Report3 = () => (
  <Document>
    <Page style={styles.body}>
      {/* <View style={styles.header}> */}

      <View style={styles.header1}>
        <Text style={styles.header3}>{'    '}</Text>
        <Text style={styles.header4}>แบบ กฟผ.-กจ.3</Text>
        <Text> </Text>
      </View>
      <View style={styles.header2}>
        <Text>การไฟฟ้าฝ่ายผลิตแห่งประเทศไทย</Text>
        <Text style={styles.header3}>สัญญารักษาผลประโยชน์ของ กฟผ.</Text>
        <Text style={styles.header3}>{'    '}</Text>
        <Text style={styles.detail1}>
          สัญญาฉบับนี้ทําที่
          .................................................... เมื่อวันที่
          ............... เดือน ........................
        </Text>
        <Text style={styles.detail2}>
          พ.ศ. ............ ระหว่างการไฟฟ้าฝ่ายผลิตแห่งประเทศไทย (กฟผ.) โดย
          .........................................................
        </Text>
        <Text style={styles.detail2}>
          ตำแหน่ง.............................................. ผู้รับมอบอำนาจ
          ซึ่งต่อไปนี้ในสัญญานี้เรียกว่า "กฟผ." ฝ่ายหนึ่งกับ
        </Text>
        <Text style={styles.detail2}>
          .............................................................. อายุ
          ......... ปี ที่อยู่ตามสําเนาทะเบียนบ้าน อยู่บ้านเลขที่ ..............
        </Text>
        <Text style={styles.detail2}>
          หมู่ที่ ....................... ตรอก/ซอย
          ................................................. ถนน
          ..........................................................
        </Text>
        <Text style={styles.detail2}>
          ตําบล/แขวง ................................... อําเภอ/เขต
          ............................................ จังหวัด
          ...................................
        </Text>
        <Text style={styles.detail2}>
          รหัสไปรษณีย์ .................. หมายเลขโทรศัพท์
          .......................... ซึ่งปฏิบัติงานในตําแหน่ง
          ............................
        </Text>
        <Text style={styles.detail2}>
          หมายเลขประจําตัว ........................ สังกัดแผนก
          ....................................... กอง
          ..........................................
        </Text>
        <Text style={styles.detail2}>
          ฝ่าย .........................................................
          รหัสสังกัด ............................................. เข้าทํางานที่
          กฟผ. ตั้งแต่
        </Text>
        <Text style={styles.detail2}>
          วันที่ ................... เดือน ................................ พ.ศ.
          ............... ซึ่งต่อไปนี้ในสัญญาจะเรียกว่า “ผู้ปฏิบัติงาน”
        </Text>
        <Text style={styles.detail2}>อีกฝ่ายหนึ่ง</Text>
        <Text style={styles.detail2}>{'     '}</Text>
        <Text style={styles.detail3}>
          คู่สัญญาทั้งสองฝ่ายตกลงทําสัญญากัน ดังต่อไปนี้
        </Text>
        <Text style={styles.detail3}>
          ข้อ 1 ผู้ปฏิบัติงาน ให้สัญญาว่าจะปฏิบัติตามนโยบาย และระเบียบปฏิบัติของ
          กฟผ. อย่างเคร่งครัด
        </Text>
        <Text style={styles.detail3}>
          ข้อ 2 ผู้ปฏิบัติงาน ให้สัญญาว่าตลอดระยะเวลาที่เป้นผู้ปฏิบัติงานของ
          กฟผ. รวมทั้งเมื่อพ้นสภาพ
        </Text>
        <Text style={styles.detail2}>
          จากการเป็นผู้ปฏิบัติงาน ของ กฟผ. ไปแล้วไม่น้อยกว่า 3 ปี
          ผู้ปฏิบัติงานจะไม่เปิดเผยข้อมูลของ กฟผ. รวมทั้ง
        </Text>
        <Text style={styles.detail2}>
          ข้อมูลของบุคคลภายนอกที่ กฟผ.
          ได้รับและมีหน้าที่ต้องรักษาข้อมูลดังกล่าวไว้เป็นความลับ ซึ่งต่อไปนี้
        </Text>
        <Text style={styles.detail2}>
          เรียกว่า “ข้อมูลที่เป็นความลับ” หรือกระทําการโดยจงใจ
          หรือประมาทเลินเล่อ หรือละเว้นกระทําการใด ๆ
        </Text>
        <Text style={styles.detail2}>
          จนเป็นเหตุให้บุคคลภายนอกล่วงรู้ถึงข้อมูลที่เป็นความลับ
          หรือนําข้อมูลที่เป็นความลับไปเปิดเผย
        </Text>
        <Text style={styles.detail3}>
          ข้อ 3 ตราบเท่า ที่ไม่ขัดต่อกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้อง
          การเปิดเผยข้อมูลใน
        </Text>
        <Text style={styles.detail2}>
          กรณีดังต่อไปนี้ไม่ถือว่าเป็นการผิดสัญญา
        </Text>
        <Text style={styles.detail4}>
          (1) การเปิดเผยข้อมูลที่ได้มีการเปิดเผยให้แก่สาธารณชนทราบแล้ว
        </Text>
        <Text style={styles.detail4}>
          (2) ผู้ปฏิบัติงานมีหน้าที่ตามกฎหมายต้องเปิดเผยข้อมูลดังกล่าว
          แต่จะต้องได้รับ
        </Text>
        <Text style={styles.detail2}>
          ความยินยอมจากผู้บังคับบัญชาชั้นผู้อํานวยการฝ่ายขึ้นไปก่อน
        </Text>
        <Text style={styles.detail2}>{'    '}</Text>
      </View>

      {/* </View> */}
    </Page>
  </Document>
);

export default Report3;
